<template>
  <el-dialog
    :title="title"
    :visible.sync="viewDialog"
    width="45%"
    :before-close="beforeClose"
    :destroy-on-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    ref="dialog"
  >
    <slot> </slot>
    <div slot="footer" class="dialog-footer">
      <el-button class="mr-1" @click="close">{{ cancelText }}</el-button>
      <slot name="footer"></slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "AppDialog",
  props: {
    title: {},
    preventClose: {},
    cancelText: {
      default: "Cancel"
    }
  },
  data() {
    return {
      viewDialog: false
    };
  },
  methods: {
    beforeClose(done) {
      if (this.preventClose) return false;
      else return done();
    },
    open() {
      this.viewDialog = true;
    },
    close() {
      setTimeout(() => {
        if (this.preventClose) return false;
        this.viewDialog = false;
      }, 100);
    }
  }
};
</script>

<style lang="css">
.el-dialog__body {
    padding-top: 10px;
    padding-bottom: 10px;
}
.el-dialog__footer {
    padding-top: 20px;
    border-top: 1px solid #ddd;
}
.dialog-footer {
    display: flex;
    justify-content: flex-end;
}
</style>
